import { Component, OnInit } from '@angular/core';
import { UploadFilesService } from '../../services/upload-files.service';

@Component({
  selector: 'app-carga-info',
  templateUrl: './carga-info.component.html',
  styleUrls: ['./carga-info.component.scss']
})
export class CargaInfoComponent implements OnInit {

  isCharging:boolean=false

  constructor(private uploadFileService:UploadFilesService) { }

  ngOnInit() {
  }

  openFile(file:string){
    if(file=="asignacion"){
      let iFile:any=document.querySelector("#fileAsignacion")
      iFile.click()
    } 
    if(file=="telefonos"){
      let iFile:any=document.querySelector("#fileTelefonos")
      iFile.click()
    } 
    if(file=="pagos"){
      let iFile:any=document.querySelector("#filePagos")
      iFile.click()
    } 
    if(file=="paleta"){
      let iFile:any=document.querySelector("#filePaleta")
      iFile.click()
    } 

    if(file=="recaudo"){
      let iFile:any=document.querySelector("#fileRecaudo")
      iFile.click()
    } 

    if(file=="acuerdo_historico"){
      let iFile:any=document.querySelector("#fileAcuerdoHistorico")
      iFile.click()
    } 

    if(file=="gestion_historica"){
      let iFile:any=document.querySelector("#fileGestionHistorica")
      iFile.click()
    } 
  }

  changeUploadFile(nro:number){
    this.isCharging=true
    let file:any
    if(nro==1){
      file=document.querySelector("#fileAsignacion");
    }else if(nro==2){
      file=document.querySelector("#fileTelefonos");
    }else if(nro==3){
      file=document.querySelector("#filePagos");
    }else if(nro==4){
      file=document.querySelector("#filePaleta");
    }else if(nro==5){
      file=document.querySelector("#fileRecaudo");
    }else if(nro==6){
      file=document.querySelector("#fileAcuerdoHistorico");
    }else{
      file=document.querySelector("#fileGestionHistorica");
    }
    
    let previewFile:any=document.querySelector(".fileSelect")
    file=file.value.replace(/C:\\fakepath\\/i,'');
    previewFile.innerHTML=file
    setTimeout(()=>{
      this.uploadFileData(nro)
    },1500)
  }

  uploadFileData(nro:number){
      let previewFile:any=document.querySelector(".fileSelect")
      
      
      var formData = new FormData();
      let fileData:any
      if(nro==1){
        fileData = document.querySelector('#fileAsignacion') as HTMLInputElement;
      }else if(nro==2){
        fileData = document.querySelector('#fileTelefonos') as HTMLInputElement;
      }else if(nro==3){
        fileData = document.querySelector('#filePagos') as HTMLInputElement;
      }else if(nro==4){
        fileData = document.querySelector('#filePaleta') as HTMLInputElement;
      }else if(nro==5){
        fileData = document.querySelector('#fileRecaudo') as HTMLInputElement;
      }else if(nro==6){
        fileData = document.querySelector('#fileAcuerdoHistorico') as HTMLInputElement;
      }else{
        fileData = document.querySelector('#fileGestionHistorica') as HTMLInputElement;
      }
      
      const fileInfo=fileData.files instanceof FileList
      ? fileData.files[0] : ''
      formData.append("archivo", fileInfo);

      if(nro==1){
        this.uploadFileService.uploadFile(formData).subscribe((data:any)=>{
          previewFile.innerHTML=previewFile.innerHTML+" - Archivo Cargado"
        })
      }else if(nro==2){
        this.uploadFileService.uploadFileTelefonos(formData).subscribe((data:any)=>{
          previewFile.innerHTML=previewFile.innerHTML+" - Archivo Cargado"
        })
      }else if(nro==3){
        this.uploadFileService.uploadFilePagos(formData).subscribe((data:any)=>{
          previewFile.innerHTML=previewFile.innerHTML+" - Archivo Cargado"
        })
      }else if(nro==4){
        this.uploadFileService.uploadFilePaleta(formData).subscribe((data:any)=>{
          previewFile.innerHTML=previewFile.innerHTML+" - Archivo Cargado"
        })
      }else if(nro==5){
        this.uploadFileService.uploadFileDatosRecaudo(formData).subscribe((data:any)=>{
          previewFile.innerHTML=previewFile.innerHTML+" - Archivo Cargado"
        })
      }else if(nro==6){
        this.uploadFileService.uploadFileAcuerdoHistorico(formData).subscribe((data:any)=>{
          previewFile.innerHTML=previewFile.innerHTML+" - Archivo Cargado"
        })
      }else{
        this.uploadFileService.uploadFileGestionHistorica(formData).subscribe((data:any)=>{
          previewFile.innerHTML=previewFile.innerHTML+" - Archivo Cargado"
        })
      }
      
  }

}
